import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import CodeInput_vue_vue_type_script_setup_true_lang_default from "./CodeInput.vue.script.js";
/* empty css                        */
/* empty css                          */
//#region src/v2/components/code-input/CodeInput.vue
var CodeInput_default = /*#__PURE__*/ _plugin_vue_export_helper_default(CodeInput_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-dbc85839"]]);
//#endregion
export { CodeInput_default as default };

//# sourceMappingURL=CodeInput.vue.js.map